import React, { Component, Fragment } from 'react';
import { Message } from 'semantic-ui-react';

import { Filter, Main } from 'Containers';

class NotFound extends Component {
  render() {
    return (
      <Fragment>
        <Filter title="Page Not Found" isError />
        <Main>
          <Message
            error
            header="You are seeing this page for one of the following reasons.."
            list={[
              'The page does not exist.',
              'You are attempting to access a page in which you do not have the proper permissions to view.',
            ]}
            style={{ marginTop: '20px' }}
          />
        </Main>
      </Fragment>
    );
  }
}

export { NotFound };



// WEBPACK FOOTER //
// ./src/pages/notfound/NotFound.js